import { useEffect, useState, useMemo } from 'react'
import { Autocomplete } from '@enterprise-ui/canvas-ui-react-autocomplete'
import _ from 'lodash'

export const AutocompleteFilter = (props) => {
  const {
    fieldName,
    requestType,
    optionsRequest,
    selectedOptions,
    value,
    sortOptions,
    loadingStaticOptions,
  } = props

  const [optionsData, setOptionsData] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [waitingOnResponse, setWaitingOnResponse] = useState(true)

  const debounceFn = useMemo(
    () =>
      _.debounce((input, field) => {
        setWaitingOnResponse(true)
        optionsRequest(field, input, 200)
          .then((response) => {
            if (response?.status === 200) {
              setWaitingOnResponse(false)
              setOptionsData(
                sortOptions ? sortOptions(response?.data) : response?.data,
              )
            } else {
              setOptionsData([])
              setWaitingOnResponse(false)
            }
          })
          .catch(() => {
            setOptionsData([])
            setWaitingOnResponse(false)
          })
      }, 250),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [optionsRequest, fieldName],
  )

  useEffect(() => {
    if (requestType === 'debounce' && inputValue !== undefined) {
      debounceFn(inputValue, fieldName)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue, fieldName])

  useEffect(() => {
    if (requestType === 'singleRequest') {
      setOptionsData([])
      optionsRequest(fieldName)
        .then((response) => {
          if (response?.status === 200) {
            setWaitingOnResponse(false)
            setOptionsData(
              sortOptions ? sortOptions(response?.data) : response?.data,
            )
          } else {
            setWaitingOnResponse(false)
          }
        })
        .catch(() => {
          setWaitingOnResponse(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldName])

  useEffect(() => {
    if (requestType === 'staticList') {
      setWaitingOnResponse(false)
      setOptionsData(sortOptions ? sortOptions(optionsRequest) : optionsRequest)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsRequest, fieldName])

  useEffect(() => {
    if (optionsData?.length && value?.length) {
      const newValues = [...value]
      newValues.forEach((valueObj, index) => {
        optionsData.forEach((optionObj) => {
          if (optionObj.value === valueObj.value) {
            newValues[index] = optionObj
          }
        })
      })
      if (!_.isEqual(newValues, value)) {
        selectedOptions(newValues)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsData])

  const displayOptions = (currentlySelectedOptions, nonSelectedOptions) => {
    if (!currentlySelectedOptions || currentlySelectedOptions?.length === 0) {
      return nonSelectedOptions
    }
    let tempList = nonSelectedOptions.filter(
      (option) => !currentlySelectedOptions.find((rm) => rm.id === option.id),
    )
    return currentlySelectedOptions?.concat(tempList)
  }

  return (
    <>
      <Autocomplete
        className="hesp-autofilter"
        {...props}
        options={(inputString) => {
          setInputValue(inputString)
          return displayOptions(value, optionsData)
        }}
        noResultsMessage={
          waitingOnResponse || loadingStaticOptions
            ? 'Loading Options...'
            : 'No Matching Results'
        }
        onUpdate={(id, value) => selectedOptions(value || [])}
        value={props.multiselect ? value : value?.[0]}
      />
    </>
  )
}
